/* eslint-disable vue/valid-v-bind */
<template>
  <div>
    <b-row>
      <b-col v-if="$can('CreateLink', 'Order')" md="3">
        <b-button
          :to="{ name: 'create-paybylink' }"
          v-b-modal.modal-paymentoption
          variant="primary"
          class="mb-1"
        >
          <feather-icon icon="PlusIcon" class="mr-25" />
          <span>Create Order Link</span>
        </b-button>
      </b-col>
    </b-row>
    <b-card title="Orders">
      <b-row class="mb-1">
        <!-- search input -->
        <b-col>
          <section>
            <b-button
              v-b-modal.modal-filter-orders
              variant="outline-primary"
              class="d-flex"
            >
              <feather-icon icon="FilterIcon" />Filter
            </b-button>
          </section>
        </b-col>
        <b-col>
          <b-form-group
            v-if="dataFiltered == true"
            class="d-flex justify-content-center"
          >
            <!-- search input -->
            <div>
              <b-form-input
                v-model="searchTerm"
                type="search"
                placeholder="search"
              />
            </div>
          </b-form-group>
        </b-col>

        <b-col v-if="dataFiltered === true" class="d-flex justify-content-end">
          <xlsx-workbook>
            <xlsx-sheet
              v-for="sheet in sheets"
              :key="sheet.name"
              :collection="sheet.data"
              :sheet-name="sheet.name"
            />
            <xlsx-download>
              <b-button variant="primary" class="d-flex">
                <feather-icon icon="DownloadCloudIcon" /> Export
              </b-button>
            </xlsx-download>
          </xlsx-workbook>
        </b-col>
      </b-row>
      <!-- table -->

      <vue-good-table
        :columns="columns"
        :rows="rows"
        :rtl="direction"
        :search-options="{
          enabled: true,
          externalQuery: searchTerm,
        }"
        :pagination-options="{
          enabled: true,
          perPage: pageLength,
        }"
      >
        <template slot="table-row" slot-scope="props">
          <!-- Column: Name -->
          <span v-if="props.column.field === 'fullName'" class="text-nowrap">
            <b-avatar :src="props.row.avatar" class="mx-1" />
            <span class="text-nowrap">{{ props.row.fullName }}</span>
          </span>

          <!-- <span
            v-if="props.column.field === 'orderId'"
            class="text-nowrap"
          >
            <span class="text-nowrap">{{ props.row.orderId }}</span>
          </span> -->

          <b-link
            v-if="props.column.field === 'orderId'"
            :to="{ name: 'order-detail', params: { id: props.row.id } }"
            target="_blank"
          >
            <feather-icon icon="EyeIcon" />
            <span class="align-middle ml-50">{{ props.row.orderId }}</span>
          </b-link>

          <!-- Column: Status -->
          <span v-else-if="props.column.field === 'recordStatus'">
            <b-badge :variant="statusVariant(props.row.recordStatus === 2)">
              {{ props.row.recordStatus == 2 ? "Active" : "InActive" }}
            </b-badge>
          </span>

          <!-- Column: Action -->
          <span v-else-if="props.column.field === 'action'">
            <span>
              <b-row v-if="props.row.paymentStatus !== 3">
                <!-- v-else-if="props.row.Payment_Status==='pending'" -->
                <b-dropdown
                  variant="link"
                  class="m-4"
                  no-caret
                  :right="$store.state.appConfig.isRTL"
                >
                  <template v-slot:button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="text-body align-middle mr-25"
                    />
                  </template>
                  <b-dropdown-item
                    v-if="
                      props.row.paymentStatus === 2 && $can('Resend', 'Order')
                    "
                    variant="primary"
                    href="#"
                    @click="resendOrder(props.row)"
                  >
                    <feather-icon class="blue-icon" icon="RepeatIcon" />
                    <span class="align-middle ml-50">Resend</span>
                  </b-dropdown-item>

                  <b-dropdown-item
                    v-if="
                      props.row.paymentStatus === 2 &&
                      props.row.refundStatus === 0 &&
                      $can('InitiateRefund', 'Order')
                    "
                    variant="primary"
                    href="#"
                    @click="initiateRefundRequest(props.row)"
                  >
                    <feather-icon class="blue-icon" icon="RepeatIcon" />
                    <span class="align-middle ml-50">Initiate Refund</span>
                  </b-dropdown-item>

                  <b-dropdown-item
                    variant="primary"
                    href="#"
                    v-if="$can('GetOrderHistories', 'Orders')"
                    @click="viewOrderHistory(props.row)"
                  >
                    <feather-icon class="blue-icon" icon="RefreshCwIcon" />
                    <span class="align-middle ml-50">History</span>
                  </b-dropdown-item>

                  <b-dropdown-item
                    variant="primary"
                    href="#"
                    v-if="$can('GetOrderPartnerTransactionHistory', 'Orders')"
                    @click="viewPartnerHistory(props.row)"
                  >
                    <feather-icon class="blue-icon" icon="RefreshCwIcon" />
                    <span class="align-middle ml-50">Partner History</span>
                  </b-dropdown-item>

                  <b-dropdown-item
                    variant="primary"
                    href="#"
                    @click="viewOrderRefundHistory(props.row)"
                  >
                    <feather-icon class="blue-icon" icon="RefreshCcwIcon" />
                    <span class="align-middle ml-50">Refund History</span>
                  </b-dropdown-item>

                  <b-dropdown-item
                    v-if="
                      props.row.paymentStatus === 1 && $can('Approve', 'Order')
                    "
                    href="#"
                    variant="success"
                    @click="approveOrder(props.row)"
                  >
                    <feather-icon class="blue-icon" icon="CheckIcon" />
                    <span class="align-middle ml-50">Approve</span>
                  </b-dropdown-item>

                  <b-dropdown-item
                    v-if="
                      props.row.paymentStatus === 1 && $can('Cancel', 'Order')
                    "
                    href="#"
                    variant="danger"
                    @click="cancelOrder(props.row)"
                  >
                    <feather-icon class="red-icon" icon="Trash2Icon" />
                    <span class="align-middle ml-50">Cancel</span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      props.row.paymentStatus === 1 && $can('Extend', 'Order')
                    "
                    href="#"
                    variant="info"
                    @click="extendOrder(props.row)"
                  >
                    <feather-icon class="yellow-icon" icon="CalendarIcon" />
                    <span class="align-middle ml-50">Extend Expiry</span>
                  </b-dropdown-item>
                </b-dropdown>
              </b-row>
            </span>
          </span>

          <span v-else-if="props.column.field === 'paymentStatusDescription'">
            <span>
              <b-badge
                v-if="props.row.paymentStatus === 2"
                pill
                variant="success"
              >
                Approved
              </b-badge>
              <b-badge
                v-else-if="props.row.paymentStatus === 3"
                pill
                variant="danger"
              >
                Canceled
              </b-badge>
              <b-badge
                v-else-if="props.row.paymentStatus === 1"
                pill
                variant="warning"
              >
                Pending
              </b-badge>
              <b-badge v-else pill variant="info">
                {{ props.row.paymentStatusDescription }}
              </b-badge>
            </span>
          </span>

          <span v-else-if="props.column.field === 'refundStatus'">
            <span>
              <b-badge
                v-if="props.row.refundStatus === 0"
                pill
                variant="secondary"
              >
                Not Requested
              </b-badge>
              <b-badge
                v-else-if="props.row.refundStatus === 1"
                pill
                variant="warning"
              >
                Pending
              </b-badge>
              <b-badge
                v-else-if="props.row.refundStatus === 2"
                pill
                variant="info"
              >
                Submitted
              </b-badge>
              <b-badge
                v-else-if="props.row.refundStatus === 3"
                pill
                variant="success"
              >
                Approved
              </b-badge>
              <b-badge
                v-else-if="props.row.refundStatus === 4"
                pill
                variant="primary"
              >
                Sent
              </b-badge>
              <b-badge
                v-else-if="props.row.refundStatus === 5"
                pill
                variant="danger"
              >
                Rejected
              </b-badge>
              <b-badge
                v-else-if="props.row.refundStatus === 6"
                pill
                variant="info"
              >
                Completed
              </b-badge>
            </span>
          </span>

          <!-- Column: Common -->
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>

        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap"> Showing 1 to </span>
              <b-form-select
                v-model="pageLength"
                :options="['5', '10', '15', '30', '50']"
                class="mx-1"
                @input="
                  (value) => props.perPageChanged({ currentPerPage: value })
                "
              />
              <span class="text-nowrap"> of {{ props.total }} entries </span>
            </div>
            <div>
              <b-pagination
                :value="1"
                :total-rows="props.total"
                :per-page="pageLength"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @input="(value) => props.pageChanged({ currentPage: value })"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>

      <b-row>
        <b-col>
          <b-modal
            id="modal-filter-orders"
            title="Filter Order"
            ok-title="Search"
            cancel-variant="outline-secondary"
            size="lg"
            @ok="filterOrders"
          >
            <b-form>
              <b-row>
                <b-col cols="6">
                  <b-form-group label="Order Id" label-for="orderid">
                    <b-form-input id="orderid" v-model.trim="filterOrderId" />
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group
                    label="Ordered Payment option"
                    label-for="payment-option"
                  >
                    <b-form-select
                      id="merchantId"
                      v-model="filterOrderFopId"
                      :options="paymentOptions"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group
                    label="Payment Status"
                    label-for="payment-status"
                  >
                    <b-form-select
                      id="merchantId"
                      v-model="filterStatus"
                      :options="statusOptions"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group
                    label="Paid Payment option"
                    label-for="payment-option"
                  >
                    <b-form-select
                      id="merchantId"
                      v-model="filterPaidFopId"
                      :options="paidPaymentOptions"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label="First Name" label-for="first-name">
                    <b-form-input id="first-name" v-model="filterFirstName" />
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label="Last Name" label-for="last-name">
                    <b-form-input id="last-name" v-model="filterLastName" />
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label="Customer Phone" label-for="phone-number">
                    <b-form-input id="phone-number" v-model="filterPhone" />
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label="Trace Number" label-for="trace-number">
                    <b-form-input
                      id="trace-number"
                      v-model="filterTraceNumber"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label="Currency" label-for="currency">
                    <b-form-select
                      id="merchantId"
                      v-model="selectedCurrency"
                      :options="currencyOptions"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group
                    label="Custom OrderCode"
                    label-for="CustomOrderCode"
                  >
                    <b-form-input
                      id="CustomOrderCode"
                      v-model="CustomOrderCode"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group
                    label="Vendor Txn RefNumber"
                    label-for="vendorTxnRefNumber"
                  >
                    <b-form-input
                      id="VendorTxnRefNumber"
                      v-model="VendorTxnRefNumber"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="2">
                  <b-form-group label="From Ammount" label-for="from-ammount">
                    <b-form-input
                      id="from-ammount"
                      v-model="filterFromAmmount"
                    />
                  </b-form-group>
                </b-col>

                <b-col cols="2">
                  <b-form-group label="To Ammount" label-for="to-ammount">
                    <b-form-input id="to-ammount" v-model="filterToAmmount" />
                  </b-form-group>
                </b-col>

                <b-col md="4">
                  <b-form-group>
                    <h5>Paid Date Range</h5>
                    <flat-pickr
                      v-model="trxnDateRange"
                      class="form-control"
                      :config="{ mode: 'range', maxDate: 'today' }"
                    />
                  </b-form-group>
                </b-col>

                <b-col md="4">
                  <b-form-group>
                    <h5>Order Date Range</h5>
                    <flat-pickr
                      v-model="orderDateRange"
                      class="form-control"
                      :config="{ mode: 'range', maxDate: 'today' }"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>
          </b-modal>
          <b-modal
            id="modal-extend-orders"
            title="Are You Sure to Exted the Order?"
            ok-title="Save"
            header-bg-variant="warning"
            cancel-variant="outline-secondary"
            size="lg"
            @ok="submitExtendedDate"
          >
            <b-form>
              <strong>Choose a date for Order: {{ selectedOrder }}</strong>
              <hr />
              <b-row>
                <b-col cols="6">
                  <div>
                    <b-form-datepicker
                      id="extended-date"
                      v-model="extendedDate"
                      class="mb-2"
                    />
                  </div>
                </b-col>
              </b-row>
            </b-form>
          </b-modal>

          <b-modal
            id="modal-order-history"
            title="Order History"
            ok-title="Ok"
            hide-footer
            cancel-variant="outline-secondary"
            size="lg"
            scrollable
          >
            <b-row>
              <b-col>
                <b-table
                  striped
                  :items="orderHistory"
                  :fields="orderHistories"
                  caption-top
                />
              </b-col>
            </b-row>
          </b-modal>
          <b-modal
            id="modal-partner-history"
            title="Partner History"
            ok-title="Ok"
            hide-footer
            cancel-variant="outline-secondary"
            size="lg"
            scrollable
          >
            <b-row>
              <b-col>
                <b-table
                  striped
                  :items="orderTransactionHistory"
                  :fields="orderPartnerHistories"
                  caption-top
                />
              </b-col>
            </b-row>
          </b-modal>

          <b-modal
            id="modal-orderRefund-history"
            title="Order Refund History"
            ok-title="Ok"
            hide-footer
            cancel-variant="outline-secondary"
            size="lg"
            scrollable
          >
            <h3>Refund History for Order Code :{{ selectedOrderRefund }}</h3>
            <hr />
            <b-row>
              <div v-for="item in orderRefundHistory" :key="item.attemptNumber">
                <b-col md="12">
                  <b-card-actions
                    :title="item.attemptNumberDescription"
                    action-collapse
                  >
                    <b-card-text>
                      <b-table
                        striped
                        :items="item.refundWorkFlowHistories"
                        :fields="orderRefundHistories"
                        caption-top
                      />
                    </b-card-text>
                  </b-card-actions>
                </b-col>
              </div>
            </b-row>
          </b-modal>

          <b-modal
            id="modal-initiate-refund"
            title="Order Initiate Refund"
            ok-title="Ok"
            hide-footer
            cancel-variant="outline-secondary"
            size="lg"
            scrollable
          >
            <div>
              <b-card>
                <h4>Refund Request</h4>
                <b-row>
                  <b-col md="6">
                    <b-form-group label="Order Code" label-for="orderCode">
                      <b-form-input
                        id="orderCode-input"
                        v-model="refundRequest.orderCode"
                        disabled
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group label="Amount" label-for="amount">
                      <b-form-input
                        id="amount-input"
                        v-model.number="refundRequest.amount"
                        type="number"
                        :state="refundRequest.amount <= amount"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group label="Currency" label-for="currency">
                      <b-form-input
                        id="approvedURI-input"
                        v-model="refundRequest.currency"
                        disabled
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group
                      label="Refund To Separate Account"
                      label-for="refundToSeparateAccount"
                    >
                      <b-form-checkbox
                        id="refundToSeparateAccount-input"
                        v-model="refundRequest.isRefundToSeparateAccountNumber"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col
                    v-if="refundRequest.isRefundToSeparateAccountNumber"
                    md="6"
                  >
                    <b-form-group
                      label="Account Number"
                      label-for="accountNumber"
                    >
                      <b-form-input
                        id="accountNumber-input"
                        v-model="refundRequest.accountNumber"
                        type="number"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <br />

                <br />
                <b-button
                  variant="primary"
                  type="submit"
                  @click="sendRefundRequest"
                >
                  Request
                </b-button>
              </b-card>
            </div>
          </b-modal>
        </b-col>
      </b-row>

      <b-modal
        id="modal-reference-number"
        ref="modal"
        header-bg-variant="warning"
        :title="titleApprove"
        @show="resetModal"
        @hidden="resetModal"
        @ok="handleOk"
      >
        <form ref="form" @submit.stop.prevent="handleSubmit">
          <b-form-group
            label=" Please Provide Reference Number"
            label-for="name-input"
            invalid-feedback="Reference is required"
            :state="referenceState"
          >
            <b-form-input
              id="name-input"
              v-model="referenceNumber"
              :state="referenceState"
              required
            />
          </b-form-group>
          <b-form-group
            label="Please select Paid Payment Option"
            label-for="defaul-tPayment-Option"
          >
            <b-form-select
              v-model="paidPaymentOption"
              :options="paymentOptions"
            />
          </b-form-group>
        </form>
      </b-modal>
      <!-- loadings -->
      <b-overlay :show="isLoading" no-wrap rounded="sm" />
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BAvatar,
  BButton,
  BBadge,
  BPagination,
  BOverlay,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BFormDatepicker,
  BDropdownItem,
  BRow,
  BCol,
  BForm,
  BLink,
  BTable,
  BCardText,
  BFormCheckbox,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import axios from "@axios";
import store from "@/store";
import flatPickr from "vue-flatpickr-component";
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import XlsxSheet from "../../../../node_modules/vue-xlsx/dist/components/XlsxSheet";
import XlsxDownload from "../../../../node_modules/vue-xlsx/dist/components/XlsxDownload";
import XlsxWorkbook from "../../../../node_modules/vue-xlsx/dist/components/XlsxWorkbook";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    VueGoodTable,
    BAvatar,
    BBadge,
    BButton,
    BOverlay,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BFormDatepicker,
    flatPickr,
    BForm,
    BLink,
    BTable,
    BCardText,
    BCardActions,
    BFormCheckbox,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
  },
  data() {
    const nowDate = new Date();
    return {
      isLoading: false,
      dataFiltered: false,
      selectedOrderRefund: "",
      rows: [],
      pageLength: 5,
      isDeleteModel: false,
      dir: false,
      rangeDate: null,
      activeRow: null,
      extendedDate: `${nowDate.getUTCFullYear()}-${
        nowDate.getUTCMonth() + 1
      }-${nowDate.getUTCDate()}`,
      orderDateRange: "",
      trxnDateRange: "",
      VendorTxnRefNumber: "",
      orderStartDate: "",
      trxnStartDate: "",
      orderEndDate: "",
      trxnEndDate: "",
      orderFirstName: "",
      orderLastName: "",
      orderEmail: "",
      orderPhone: "",
      orderAmount: "",
      orderCurrency: "",
      orderCity: "",
      orderCountry: "",
      orderChannel: "",
      selectedOrder: "",
      filterOrderId: "",
      filterOrderFopId: 0,
      filterPaidFopId: 0,
      filterFirstName: "",
      filterLastName: "",
      filtertrnxDate: "",
      filterPhone: "",
      filterTraceNumber: "",
      filterToAmmount: 0,
      filterFromAmmount: 0,
      filterStatus: 0,
      filterOrderType: 3,
      CustomOrderCode: "",

      columns: [
        {
          label: "First Name",
          field: "firstName",
        },
        {
          label: "Last Name",
          field: "lastName",
        },
        {
          label: "FOP",
          field: "paymentOptionName",
        },
        {
          label: "Order Date",
          field: "orderDateString",
        },
        {
          label: "Custome Order Code",
          field: "customOrderCode",
        },
        {
          label: "Order Id",
          field: "orderId",
        },
        {
          label: "Amount",
          field: "amount",
        },
        {
          label: "Payment Status",
          field: "paymentStatusDescription",
        },
        {
          label: "Paid FOP",
          field: "paidPaymentOptionName",
        },
        {
          label: "Paid Date",
          field: "paidDateString",
        },
        {
          label: "Expiry Date",
          field: "expiryDateString",
        },

        {
          label: "Reference Number",
          field: "vendorTxnRefNumber",
        },

        {
          label: "Action",
          field: "action",
        },
      ],
      sheets: [{ name: "Detail Orders", data: [] }],
      paymentOptions: [{ value: 0, text: "--select Orderd Payment Option--" }],
      paidPaymentOptions: [
        { value: 0, text: "--select Paid Payment Option--" },
      ],

      statusOptions: [
        { value: "0", text: "All" },
        { value: "1", text: "Pending" },
        { value: "2", text: "Approved" },
        { value: "3", text: "Canceled" },
      ],
      refundStatusOptions: [
        { value: "0", text: "NotRequested" },
        { value: "1", text: "Pending" },
        { value: "2", text: "Submitted" },
        { value: "3", text: "Approved" },
        { value: "4", text: "Sent" },
        { value: "5", text: "Rejected" },
        { value: "6", text: "Completed" },
      ],
      currencyOptions: [{ value: "ETB", text: "ETB" }],
      orderTypeOptions: [
        { value: "0", text: "All" },
        { value: "1", text: "System Initiated" },
        { value: "2", text: "Manual Created" },
        { value: "3", text: "Pay by link" },
      ],
      selectedCurrency: "ETB",
      searchTerm: "",
      editabelData: {},
      orderHistory: [],
      orderTransactionHistory: [],
      orderRefundHistory: [],
      orderHistories: [
        "paymentStatusDescription",
        "transactionDate",
        "actionTakenDescription",
        "actionTakenBy",
      ],
      orderPartnerHistories: [
        "messageTypeDescription",
        "messageDirectionDescription",
        "paymentOptionDescription",
        "requestMSG",
        "statusDescription",
        "actionTakenBy",
      ],
      // orderRefundHistories: ['level', 'actionDescription', 'transactionDate', 'actionTakenBy'],
      orderRefundHistories: [
        {
          key: "level",
          label: "Level",
        },
        {
          key: "actionDescription",
          label: "Action",
        },
        {
          key: "transactionDate",
          label: "Date",
        },
        {
          key: "actionTakenBy",
          label: "Action By",
        },
      ],
      referenceNumber: "",
      paidPaymentOption: 0,
      referenceState: null,
      selectedOrderCode: "",
      titleApprove: "",
      amount: 0,
      refundRequest: {
        orderCode: "",
        amount: 0,
        currency: "ETB",
        accountNumber: "",
        isRefundToSeparateAccountNumber: false,
      },
    };
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        1: "light-success",
        0: "light-danger",
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },
  },
  created() {
    this.fetchData();
    this.fetchallPaymentOptions();
  },
  methods: {
    fetchData() {
      this.$store.dispatch("config/getActionPrivilege", "Order-View");
      this.isLoading = true;
      axios
        .get("/Order/api/V1.0/Orders/GetOrder?orderType=3")
        .then((res) => {
          this.rows = res.orders;
          this.isLoading = false;
        })
        .catch((res) => {
          this.isLoading = false;
          this.rows = [];
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              icon: "BellIcon",
              variant: "danger",
              text: `${res.data.message}`,
            },
          });
        });
    },
    fetchallPaymentOptions() {
      this.isLoading = true;
      this.$store.dispatch("config/getActionPrivilege", "Order-View");
      axios
        .get(
          "/PaymentOptions/api/V1.0/PaymentOptions/ViewMerchantPaymentOptions",
        )
        .then((res) => {
          res.paymentOptions.forEach((item) => {
            this.paymentOptions.push({
              value: item.id,
              text: item.name,
            });
          });
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    cancelOrder(row) {
      this.$bvModal
        .msgBoxConfirm(`to Cancel Order Id  ${row.orderId}`, {
          title: "Are You Sure",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          headerBgVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.isLoading = true;
            axios
              .post("/Order/api/V1.0/Orders/CancelOrder", {
                orderId: row.orderId,
              })
              .then((res) => {
                // const orderSelected = this.rows.filter(item => item.orderId === row.orderId)
                // console.log(orderSelected)

                this.$swal({
                  icon: "success",
                  title: "Status Updated!",
                  text: res.message,
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                });
                this.isLoading = false;
                if (this.dataFiltered) {
                  this.filterOrders();
                } else {
                  this.fetchData();
                }
              })
              .catch((res) => {
                this.isLoading = false;
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "Error",
                    icon: "BellIcon",
                    variant: "danger",
                    text: `${res.data.message}`,
                  },
                });
                // this.$refs.loginForm.setErrors(error)
              });
          }
        });
    },
    approveOrder(row) {
      this.selectedOrderCode = row.orderId;
      this.titleApprove = `Are you sure to approve Order:${row.orderId}`;
      this.$bvModal.show("modal-reference-number");
    },
    initiateRefundRequest(row) {
      this.selectedOrderCode = row.orderId;
      this.refundRequest.orderCode = row.orderId;
      this.refundRequest.amount = row.amount;
      this.amount = row.amount;
      this.refundRequest.currency = row.currency;
      this.refundRequest.isRefundToSeparateAccountNumber =
        row.isRefundToSeparateAccountNumber;
      this.titleApprove = `Are you sure to Initiate refund for Order:${row.orderId}`;
      this.$bvModal.show("modal-initiate-refund");
    },
    resendOrder(row) {
      this.$bvModal
        .msgBoxConfirm(` to Resend  ${row.orderId}`, {
          title: "Are You Sure",
          size: "sm",
          buttonSize: "sm",
          okVariant: "primary",
          headerBgVariant: "primary",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.isLoading = true;
            axios
              .post("/Order/api/V1.0/Orders/ResendOrder", {
                orderId: row.orderId,
              })
              .then((res) => {
                this.$swal({
                  icon: "success",
                  title: "Order Resended!",
                  text: res.message,
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                });
                this.isLoading = false;
                if (this.dataFiltered) {
                  this.filterOrders();
                } else {
                  this.fetchData();
                }
              })
              .catch((res) => {
                this.isLoading = false;
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "Error",
                    icon: "BellIcon",
                    variant: "danger",
                    text: `${res.data.message}`,
                  },
                });
                // this.$refs.loginForm.setErrors(error)
              });
          }
        });
    },
    sendRefundRequest(row) {
      this.$bvModal
        .msgBoxConfirm(` to initiate Refund for  ${row.orderId}`, {
          title: "Are You Sure",
          size: "sm",
          buttonSize: "sm",
          okVariant: "primary",
          headerBgVariant: "primary",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.$bvModal.hide("modal-initiate-refund");
            this.isLoading = true;
            axios
              .post("/Order/api/V1.0/Refund/InitiateRefund", this.refundRequest)
              .then((res) => {
                this.isLoading = false;
                this.$swal({
                  icon: "success",
                  title: "Refund Initiated!",
                  text: res.message,
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                });
                if (this.dataFiltered) {
                  this.filterOrders();
                } else {
                  this.fetchData();
                }
              })
              .catch((res) => {
                this.isLoading = false;
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "Error",
                    icon: "BellIcon",
                    variant: "danger",
                    text: `${res.data.message}`,
                  },
                });
                // this.$refs.loginForm.setErrors(error)
              });
          }
        });
    },
    extendOrder(row) {
      this.selectedOrder = row.orderId;
      this.$bvModal.show("modal-extend-orders");
    },
    submitExtendedDate() {
      this.isLoading = true;
      axios
        .post("/Order/api/V1.0/Orders/ExtendOrder", {
          orderId: this.selectedOrder,
          expiryDate: this.extendedDate,
        })
        .then((res) => {
          this.$swal({
            icon: "success",
            title: "Order Extended!",
            text: res.message,
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
          this.isLoading = false;
          if (this.dataFiltered) {
            this.filterOrders();
          } else {
            this.fetchData();
          }
        })
        .catch((res) => {
          this.isLoading = false;
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              icon: "BellIcon",
              variant: "danger",
              text: `${res.data.message}`,
            },
          });
          // this.$refs.loginForm.setErrors(error)
        });
    },
    filterOrders() {
      if (this.orderDateRange !== "") {
        const [orderSttDate, orderEdDate] = this.orderDateRange.split(" to ");

        if (this.orderDateRange.includes("to")) {
          this.orderStartDate = orderSttDate;
          this.orderEndDate = orderEdDate;
        } else {
          this.orderStartDate = this.orderDateRange;
          this.orderEndDate = this.orderDateRange;
        }
      }

      if (this.trxnDateRange !== "") {
        const [trxnSttDate, trxnEdDate] = this.trxnDateRange.split(" to ");
        // this.trxnEndDate = `${trxnEdDate.trim()}`
        // this.trxnStartDate = `${trxnSttDate.trim()}`

        if (this.trxnDateRange.includes("to")) {
          this.trxnStartDate = trxnSttDate;
          this.trxnEndDate = trxnEdDate;
        } else {
          this.trxnStartDate = this.trxnDateRange;
          this.trxnEndDate = this.trxnDateRange;
        }
      }

      const url = `/Order/api/V1.0/Orders/FilterOrder?OrderId=${this.filterOrderId}&CustomerFirstName=${this.filterFirstName}&CustomerLastName=${this.filterLastName}&CustomerPhone=${this.filterPhone}
      &FromOrderDate=${this.orderStartDate}&ToOrderDate=${this.orderEndDate}&FromPaidDate=${this.trxnStartDate}&ToPaidDate=${this.trxnEndDate}&Currency=${this.selectedCurrency}&TraceNumber=${this.filterTraceNumber}
      &FromAmount=${this.filterFromAmmount} &ToAmount=${this.filterToAmmount}&paymentStatus=${this.filterStatus}&PaymentOptionId=${this.filterOrderFopId}&CustomOrderCode=${this.CustomOrderCode}
      &VendorTxnRefNumber=${this.VendorTxnRefNumber} &OrderType=${this.filterOrderType} &PaidPaymentOption=${this.filterPaidFopId}`;
      // Api call
      this.isLoading = true;
      axios
        .get(url)
        .then((res) => {
          this.sheets[0].data = [];
          this.dataFiltered = true;
          this.rows = res.orders;
          res.orders.map((m) => {
            this.sheets[0].data.push({
              Company: m.company,
              Merchant_Name: m.merchantName,
              First_Name: m.firstName,
              Last_Name: m.lastName,
              email: m.email,
              Phone: m.phone,
              Amount: m.amount,
              Currency: m.currency,
              City: m.city,
              Country: m.country,
              Channel: m.channel,
              Order_Id: m.orderId,
              Custom_Order_Code: m.customOrderCode,
              Order_Date: m.orderDateString,
              Order_Type: m.orderTypeDescription,
              Order_Payment_Option: m.paymentOptionName,
              Expiry_Date: m.expiryDateString,
              Payment_Status: m.paymentStatusDescription,
              Paid_Date: m.paidDateString,
              Paid_Payment_Option: m.paidPaymentOptionName,
              Vendor_Txn_RefNumber: m.vendorTxnRefNumber,
              Paid_Account_Number: m.paidAccountNumber,
              Merchant_Service_Number: m.merchantServiceNumber,
              isNotify: m.isNotify,
              Notify_Remark: m.notifyRemark,
              Confirmation_Attempt: m.confirmAttemptCount,
              Short_Code: m.shortCode,
              Authorization_ShortCode: m.authorizationShortCode,
              Trace_Numbers: m.traceNumbers,
              Refund_Requested_Date: m.refundRequestedDate,
              Refund_Account_Number: m.refundAccountNumber,
              Refund_To_Separate_Account: m.refundToSeparateAccount,
            });
          });
          this.isLoading = false;
          this.orderStartDate = "";
          this.orderEndDate = "";
          this.trxnEndDate = "";
          this.trxnStartDate = "";
        })
        .catch((res) => {
          this.isLoading = false;
          this.rows = [];
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              icon: "BellIcon",
              variant: "danger",
              text: `${res.data.message}`,
            },
          });
          // this.$refs.loginForm.setErrors(error)
          this.orderStartDate = "";
          this.orderEndDate = "";
          this.trxnEndDate = "";
          this.trxnStartDate = "";
        });
    },
    viewOrderHistory(row) {
      // Api call
      this.isLoading = true;
      axios
        .get(`/Order/api/V1.0/Orders/GetOrderHistories?orderId=${row.id}`)
        .then((res) => {
          this.orderHistory = res.orderHistories;
          this.$bvModal.show("modal-order-history");
          this.isLoading = false;
        })
        .catch((res) => {
          this.isLoading = false;
          this.$bvModal.msgBoxOk(res.data.message, {
            title: "Error",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true,
          });
        });
    },
    viewPartnerHistory(row) {
      // Api call
      this.isLoading = true;
      axios
        .get(
          `/Order/api/V1.0/Orders/GetOrderPartnerTransactionHistory?orderId=${row.id}`,
        )
        .then((res) => {
          this.orderHistory = res.orderHistories;
          this.$bvModal.show("modal-partner-history");
          this.isLoading = false;
        })
        .catch((res) => {
          this.isLoading = false;
          this.$bvModal.msgBoxOk(res.data.message, {
            title: "Error",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true,
          });
        });
    },
    viewOrderRefundHistory(row) {
      this.isLoading = true;
      this.selectedOrderRefund = row.orderId;
      // row.id = 314
      axios
        .get(
          `/Order/api/V1.0/Refund/GetOrderRefundWorkflowHistoryGroupedByAttempt?orderId=${row.id}`,
        )
        .then((res) => {
          this.orderRefundHistory = res.refundWorkFlowHistories;
          this.$bvModal.show("modal-orderRefund-history");
          this.isLoading = false;
        })
        .catch((res) => {
          this.isLoading = false;
          this.$bvModal.msgBoxOk(res.data.message, {
            title: "Error",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true,
          });
        });
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.referenceState = valid;
      return valid;
    },
    resetModal() {
      this.referenceNumber = "";
      this.referenceState = null;
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.handleSubmit();
    },
    handleSubmit() {
      if (!this.checkFormValidity()) {
        return;
      }
      this.$nextTick(() => {
        this.$bvModal.hide("modal-reference-number");
        this.isLoading = true;
        axios
          .post("/Order/api/V1.0/Orders/ApproveOrder", {
            orderId: this.selectedOrderCode,
            referenceNumber: this.referenceNumber,
          })
          .then((res) => {
            this.$swal({
              icon: "success",
              title: "Order Approved!",
              text: res.message,
              customClass: {
                confirmButton: "btn btn-success",
              },
            });
            this.isLoading = false;
            if (this.dataFiltered) {
              this.filterOrders();
            } else {
              this.fetchData();
            }
          })
          .catch((res) => {
            this.isLoading = false;
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Error",
                icon: "BellIcon",
                variant: "danger",
                text: `${res.data.message}`,
              },
            });
          });
      });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
